import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MemberDetailsReportData} from "./member-details-report.data";

@Injectable()
export class MemberDetailsReportModel extends ReportModel<MemberDetailsReportData> {
    constructor(injector: Injector) {
        super(injector, MemberDetailsReportData);
    }
}
